import apiRequest from '../../../shared/services/apiClient';

export type SsoProtocol = 'Oidc' | 'Saml';

export interface TenantSsoSettings {
  configured: boolean;
  isEnabled: boolean;
  protocol: SsoProtocol;
  allowedEmailDomains?: string | null;
  breakGlassEmail?: string | null;
  jitEnabled: boolean;
  jitDefaultRoleId?: string | null;
  oidc: {
    authority?: string | null;
    clientId?: string | null;
    hasClientSecret: boolean;
    scopes: string;
  };
  saml: {
    idpEntityId?: string | null;
    idpSsoUrl?: string | null;
    idpSloUrl?: string | null;
    hasCertificate: boolean;
    emailAttributeName: string;
  };
  serviceProvider: {
    entityId: string;
    oidcRedirectUrl: string;
    samlAcsUrl: string;
  };
}

export interface UpdateTenantSsoSettingsRequest {
  protocol: SsoProtocol;
  allowedEmailDomains?: string;
  breakGlassEmail?: string;
  jitEnabled?: boolean;
  jitDefaultRoleId?: string | null;
  oidcAuthority?: string;
  oidcClientId?: string;
  oidcClientSecret?: string;
  oidcScopes?: string;
  samlIdpEntityId?: string;
  samlIdpSsoUrl?: string;
  samlIdpSloUrl?: string;
  samlIdpCertificate?: string;
  samlEmailAttributeName?: string;
}

export const getSsoSettings = () => apiRequest<TenantSsoSettings>('/api/v1/admin/sso');

export const updateSsoSettings = (request: UpdateTenantSsoSettingsRequest) =>
  apiRequest<TenantSsoSettings>('/api/v1/admin/sso', {
    method: 'PUT',
    body: JSON.stringify(request),
  });

export const testSsoSettings = () =>
  apiRequest<{ success: boolean; message: string }>('/api/v1/admin/sso/test', {
    method: 'POST',
    body: JSON.stringify({}),
  });

export const setSsoEnabled = (enabled: boolean) =>
  apiRequest<TenantSsoSettings>('/api/v1/admin/sso/enabled', {
    method: 'POST',
    body: JSON.stringify({ enabled }),
  });
